import script from "./CareerSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CareerSkeleton.vue?vue&type=style&index=0&id=08f4b14a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f4b14a"]])

export default __exports__